import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import { projectMeasureData } from "../../../components/chart/utils";
import {
  fetchSensorDataFailure,
  fetchSensorDataStart,
  fetchSensorDataSuccess,
} from "../../../store/features/customer/sensor/sensorDataSlice";

const URL = buildApiUrl("/api/v1/instruments/sensor_data/");

const fetchSensorDataApi = async ({
  accessToken,
  id,
  from,
  to,
  filtered,
  measure,
  scope,
}) => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        id: id,
        from: from,
        to: to,
        filtered: filtered,
      },
    });

    if (response.data?.error) throw response.data;
    if (!Array.isArray(response.data)) throw new Error("Risposta dei dati del grafico non valida");
    return scope ? response.data : projectMeasureData(response.data, measure);
  } catch (error) {
    throw error.response?.data || (error.error ? error : { message: error.message });
  }
};

export function* handleFetchSensorDataSaga(action) {
  const { id: sensorId, measure, scope, requestId } = action.payload;
  const identity = scope ? { scope, requestId } : {};
  try {
    const data = yield call(fetchSensorDataApi, action.payload);
    yield put(
      fetchSensorDataSuccess({
        sensorId,
        measure,
        data,
        ...identity,
      })
    );
  } catch (error) {
    yield put(fetchSensorDataFailure(scope
      ? { ...identity, sensorId, measure, error }
      : error));
  }
}

export default function* sensorDataSaga() {
  yield takeEvery(fetchSensorDataStart.type, handleFetchSensorDataSaga);
}
